import { Capacitor } from '@capacitor/core';
import { AppStoreRegion, type AppStoreRegionInfo } from '../plugins/appStoreRegion';

export const US_APP_STORE_COUNTRY_CODE = 'USA';
export const SUBSCRIPTION_STOREFRONT_SUPPORT_MESSAGE =
  "Subscription options are temporarily unavailable in the iPhone app. Please try again or contact support for help.";

export interface IosExternalBillingDependencies {
  isNativePlatform: () => boolean;
  getPlatform: () => string;
  getStorefront: () => Promise<AppStoreRegionInfo>;
}

const defaultDependencies: IosExternalBillingDependencies = {
  isNativePlatform: () => Capacitor.isNativePlatform(),
  getPlatform: () => Capacitor.getPlatform(),
  getStorefront: () => AppStoreRegion.getStorefront(),
};

export const requiresIosStorefrontCheck = (
  deps: Pick<IosExternalBillingDependencies, 'isNativePlatform' | 'getPlatform'> = defaultDependencies
): boolean => deps.isNativePlatform() && deps.getPlatform() === 'ios';

export const isSilentMultiplatformIosClient = () => false;

export const requiresSubscriptionStorefrontCheck = requiresIosStorefrontCheck;

export const canUseIosExternalBilling = async (
  deps: IosExternalBillingDependencies = defaultDependencies
): Promise<boolean> => {
  if (!requiresIosStorefrontCheck(deps)) {
    return true;
  }

  try {
    const storefront = await deps.getStorefront();
    return storefront.isUnitedStatesStorefront;
  } catch {
    return false;
  }
};

export const isSubscriptionStorefrontSupported = canUseIosExternalBilling;
export const canShowExternalPricingForStorefront = canUseIosExternalBilling;
